import React, { createContext, useContext, useEffect, useState, useCallback } from "react";
import { api } from "../lib/api";

const LanguageContext = createContext(null);

export const LanguageProvider = ({ children }) => {
  const [lang, setLangState] = useState(() => localStorage.getItem("impec_lang") || "es");
  const [cache, setCache] = useState(() => {
    try { return JSON.parse(localStorage.getItem("impec_trans_cache") || "{}"); } catch { return {}; }
  });

  const setLang = (l) => {
    setLangState(l);
    localStorage.setItem("impec_lang", l);
  };

  useEffect(() => {
    localStorage.setItem("impec_trans_cache", JSON.stringify(cache));
  }, [cache]);

  const translate = useCallback(async (text, cacheKey) => {
    if (!text || lang === "es") return text;
    const key = `${cacheKey || text}:${lang}`;
    if (cache[key]) return cache[key];
    try {
      const { data } = await api.post("/translate", {
        text, target_lang: lang, cache_key: cacheKey ? `${cacheKey}:${lang}` : null,
      });
      const translated = data.text || text;
      setCache((prev) => ({ ...prev, [key]: translated }));
      return translated;
    } catch {
      return text;
    }
  }, [lang, cache]);

  return (
    <LanguageContext.Provider value={{ lang, setLang, translate }}>
      {children}
    </LanguageContext.Provider>
  );
};

export const useLanguage = () => useContext(LanguageContext);
